<span class="container">
  <a (click)="save($event)" #innerContent><ng-content></ng-content></a>
</span>
